module.exports = __webpack_public_path__ + "img/v2.d05626f5.png";